import { c as _c } from "react/compiler-runtime";
import { Form, type TemplateInputProps } from '@onefootprint/ui';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { ExternalApiFormData } from '../../../../types';
type PathInputProps = {
  autocompleteItems: TemplateInputProps['autocompleteItems'];
  fieldPrefix?: 'config.' | 'config.sandboxHttpProperties.';
  baseUrl?: string;
};
const PathInput = t0 => {
  const $ = _c(43);
  const {
    autocompleteItems,
    fieldPrefix: t1,
    baseUrl
  } = t0;
  const fieldPrefix = t1 === undefined ? "config." : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "externalApi.requestConfig.path"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t2);
  const {
    formState: t3
  } = useFormContext();
  const {
    disabled
  } = t3;
  let t4;
  if ($[1] !== t) {
    t4 = t(_temp);
    $[1] = t;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t4) {
    t5 = {
      label: t4,
      value: "get"
    };
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t) {
    t6 = t(_temp2);
    $[5] = t;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t6) {
    t7 = {
      label: t6,
      value: "post"
    };
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t) {
    t8 = t(_temp3);
    $[9] = t;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t8) {
    t9 = {
      label: t8,
      value: "put"
    };
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t) {
    t10 = t(_temp4);
    $[13] = t;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10) {
    t11 = {
      label: t10,
      value: "patch"
    };
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t) {
    t12 = t(_temp5);
    $[17] = t;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t12) {
    t13 = {
      label: t12,
      value: "delete"
    };
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t11 || $[22] !== t13 || $[23] !== t5 || $[24] !== t7 || $[25] !== t9) {
    t14 = [t5, t7, t9, t11, t13];
    $[21] = t11;
    $[22] = t13;
    $[23] = t5;
    $[24] = t7;
    $[25] = t9;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  const httpMethodOptions = t14;
  const t15 = `${fieldPrefix}path`;
  let t16;
  if ($[27] !== disabled || $[28] !== t) {
    t16 = disabled ? "" : t(_temp6);
    $[27] = disabled;
    $[28] = t;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  const t17 = `${fieldPrefix}method`;
  let t18;
  if ($[30] !== httpMethodOptions || $[31] !== t17) {
    t18 = <Form.Select name={t17} options={httpMethodOptions} className="[&_p]:overflow-visible! w-28 shrink-0" />;
    $[30] = httpMethodOptions;
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== baseUrl) {
    t19 = baseUrl && <div className="flex items-center px-3 bg-secondary border-1 border-r-0 border-tertiary text-body-2 text-tertiary font-mono whitespace-nowrap max-md:min-w-0 max-md:max-w-24"><span className="max-md:truncate">{baseUrl}</span></div>;
    $[33] = baseUrl;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== t18 || $[36] !== t19) {
    t20 = <div className="flex items-stretch">{t18}{t19}</div>;
    $[35] = t18;
    $[36] = t19;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  let t21;
  if ($[38] !== autocompleteItems || $[39] !== t15 || $[40] !== t16 || $[41] !== t20) {
    t21 = <Form.TemplateInput name={t15} placeholder={t16} autocompleteItems={autocompleteItems} addon={t20} />;
    $[38] = autocompleteItems;
    $[39] = t15;
    $[40] = t16;
    $[41] = t20;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  return t21;
};
export default PathInput;
function _temp($) {
  return $.httpMethod.get;
}
function _temp2($_0) {
  return $_0.httpMethod.post;
}
function _temp3($_1) {
  return $_1.httpMethod.put;
}
function _temp4($_2) {
  return $_2.httpMethod.patch;
}
function _temp5($_3) {
  return $_3.httpMethod.delete;
}
function _temp6($_4) {
  return $_4.placeholder;
}